import React from "react"
import { Flex } from "@chakra-ui/react"
import Links from "./Links"
import "../layout.css"

export default function NavBar({ children, ...props }) {
    return (
      <Flex
        as="nav"
        align="center"
        justify={["center", "flex-end"]}
        wrap="wrap"
        w="100%"
        mb={8}
        pt={8}
        pb={8}
        bg={["primary.500", "primary.500", "transparent", "transparent"]}
        color={["white", "white", "primary.700", "primary.700"]}
        {...props}
      >
        {/* <Image d="absolute" src={avatar} h={20} left={0}/> */}
        <Links />
      </Flex>
    )
  }
  